import { createContext, use, type ReactNode } from "react";

const EditorTitleContext = createContext<string>("");

export const useEditorTitle = (): string => {
  return use(EditorTitleContext);
};

export interface EditorTitleProviderProps {
  title: string;
  children: ReactNode;
}

export const EditorTitleProvider = ({
  title,
  children,
}: EditorTitleProviderProps) => {
  return <EditorTitleContext value={title}>{children}</EditorTitleContext>;
};
